import { put } from "redux-saga/effects";
import importer from "common/importer";
const ChatbotActions = importer("Stores/Chatbot/Actions");
const PublicContentActions = importer("Stores/PublicContent/Actions");
const { NAVIGATION_TYPES, DRUPAL_MENU_TYPES } = importer(
  "Sagas/Constants/drupalConstants",
  null
);
import { getMinStaticContent } from "@takedapdt/biolife-cms-kit";
import i18next from "i18next";

export default function* main() {
  try {
    yield put(PublicContentActions.getDrupalNavigationLoading());
    const data = (yield getMinStaticContent(NAVIGATION_TYPES.HEADER_FOOTER, {
      lang: i18next.language,
      filters: { field_slug_value: "web-core-components" },
    }))[0];
    const showChatbotGlobally = data?.metadata?.field_global_chatbot;
    yield put(ChatbotActions.setChatbotToGlobalView(!!showChatbotGlobally));
    yield put(ChatbotActions.showHideChatbot(true));
    yield put(PublicContentActions.getDrupalNavigationSuccess(data));
    yield put(
      PublicContentActions.drupalMenuFetch(DRUPAL_MENU_TYPES.TOP_HEADER)
    );
    yield put(PublicContentActions.drupalMenuFetch(DRUPAL_MENU_TYPES.HEADER));
    yield put(PublicContentActions.drupalMenuFetch(DRUPAL_MENU_TYPES.FOOTER));
  } catch (error) {
    yield put(PublicContentActions.getDrupalNavigationFailure(error));
  }
}
